import React, { useState, useEffect } from "react";
import cookie from "react-cookies";
import axios from "utils/axios";
import { Badge } from "@mui/material";
import MainLayout from "layout/MainLayout";
import {
  Resources,
  Ads,
  Accounts,
  Reviews,
  Pendings,
  AdminMain,
  TopAds,
} from "../Contents";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AdminDashBoard = () => {
  const [content, setContent] = useState<any>();
  const [pendingCount, setPendingCount] = useState<number>(0);

  const navigate = useNavigate();

  useEffect(() => {
    setContent(<AdminMain />);
    getPendingCount();
  }, []);

  const getPendingCount = async () => {
    try {
      const {
        data: { count },
      } = await axios.get("/api/account/pendingCount");
      setPendingCount(count);
    } catch (error) {}
  };

  const handlePending = () => {
    if (pendingCount === 0) {
      toast.success("No Pending Accounts");
    } else {
      setContent(<Pendings />);
    }
  };
  return (
    <MainLayout title="Admin Dashboard">
      <div className="containers my-16 flex gap-6 flex-col xl:flex-row sm:my-[24px]">
        <div className="flex flex-col xl:flex-row w-full gap-6">
          <div className="flex flex-col gap-10 sm:gap-[24px]">
            <div className="flex xl:flex-col gap-10 sm:gap-[16px]">
              <img
                src={cookie.load("user")?.media}
                alt="background"
                className="w-[225px] h-[150px] sm:w-[150px] sm:h-[90px]"
              />
              <span className="text-3xl font-mont text-main xl:w-[225px] block sm:text-2xl">
                {cookie.load("user")?.title}
              </span>
            </div>
            <div className="flex xl:flex-col gap-[8px] flex-wrap">
              <button
                className="main-button"
                onClick={() => setContent(<Resources />)}
              >
                RESOURCE
              </button>
              <button
                className="main-button"
                onClick={() => setContent(<Ads />)}
              >
                ADS
              </button>
              {cookie.load("user")?.userType === "admin" && (
                <>
                  <button
                    className="main-button"
                    onClick={() => setContent(<Accounts />)}
                  >
                    ACCOUNT
                  </button>
                </>
              )}
              <button
                className="main-button"
                onClick={() => setContent(<Reviews />)}
              >
                REVIEW
              </button>
              {cookie.load("user")?.userType === "admin" && (
                <button
                  className="main-button relative"
                  onClick={handlePending}
                >
                  PENDING
                  {pendingCount !== 0 && (
                    <div className="absolute -top-2 right-0">
                      <Badge
                        badgeContent={pendingCount}
                        color="primary"
                      ></Badge>
                    </div>
                  )}
                </button>
              )}
              <button
                className="main-button"
                onClick={() => navigate("/search/all")}
              >
                MAP
              </button>
            </div>
          </div>
          <div className="grow flex flex-col">{content}</div>
        </div>
        <TopAds />
      </div>
    </MainLayout>
  );
};

export default AdminDashBoard;
